export default __webpack_public_path__ + "static/media/SS.f381856f.svg";